import React from 'react'
import { useSelector } from 'react-redux'
import Modal from '~/components/common/modal'

import { translate } from '~/core/translate'
import { getSessionPolls } from '~/selectors/session-details'
import { getDialogProps } from '~/selectors/ui'
import PollList from './list'

const PollsDialog = () => {
  const { id } = useSelector(getDialogProps)
  const polls = useSelector(getSessionPolls(id))
  const title = `${translate('polls')} (${polls.length})`

  return (
    <Modal title={title}>
      <PollList id={id} />
    </Modal>
  )
}

export default PollsDialog
